<odnr-map [config]="filteredConfig" (mapLoaded)="onMapReady($event)"></odnr-map>


